import { cn } from '@/shared/lib/utils';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';

/**
 * RDS Toggle (Switch).
 * @see https://www.figma.com/design/wcgji99mZRPIytCZDjwqxe/RDS-v1.0?node-id=81-1216
 */
export const switchRootClassName = cn(
  'peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full',
  'border-0 shadow-none transition-colors',
  'focus-visible:outline-none focus-visible:shadow-[0_0_0_3px_#aeb6fb]',
  'disabled:cursor-not-allowed',
  // Off
  'data-[state=unchecked]:bg-[#d2d5db]',
  'data-[state=unchecked]:hover:bg-[#9ea2ae]',
  'data-[state=unchecked]:disabled:bg-[#e5e7ea]',
  'data-[state=unchecked]:disabled:hover:bg-[#e5e7ea]',
  // On — Primary-600 / Hover Primary-700
  'data-[state=checked]:bg-ruda-primary-600',
  'data-[state=checked]:hover:bg-ruda-primary-700',
  'data-[state=checked]:disabled:bg-[#9ea2ae]',
  'data-[state=checked]:disabled:hover:bg-[#9ea2ae]',
);

export const switchThumbClassName = cn(
  'pointer-events-none block size-5 rounded-full bg-white',
  'shadow-sm ring-0 transition-transform',
  'data-[state=unchecked]:translate-x-0.5',
  // 44px 트랙 − 20px thumb − 2px 좌우 inset → 이동 20px
  'data-[state=checked]:translate-x-[22px]',
  'group-disabled:bg-[#f3f4f6]',
);

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn('group', switchRootClassName, className)}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb className={switchThumbClassName} />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
